module.exports = __webpack_public_path__ + "static/media/web-ats-08.44b9a01c.jpeg";